module.exports = __webpack_public_path__ + "static/media/FishMissile1.1ddd5a94.jpg";